import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import Login from "../components/Login";
import Faltas from "../components/Faltas";
import ListadoFaltas from "../components/FaltasListado";
import useAuth from "../hooks/useAuth";
import RequireAuth from "../components/RequireAuth";
import PersistLogin from "../components/PersistLogin";
import Home from "../components/Home";
import { useLocation } from "react-router-dom";
import PerfilUsuario from '../components/PerfilUsuario';
import ListadoAlumnos from "../components/AlumnosListado";
import Conceptos from "../components/Conceptos";
import Cargos from "../components/Cargos";
import Pagos from "../components/Pagos";
import PagosManual from "../components/PagosManual";
import PagosMasivos from "../components/PagosMasivos";
 import PagosHistorial from "../components/PagosHistorial";
import EstadoCuenta from "../components/EstadoCuenta";
import Inventario from "../components/Inventario";
import Facturacion from "../components/Facturacion";

const ROLES = {
  User: 2001,
  Editor: 1984,
  Admin: 5150,
};
export function MyRoutes() {
  const location = useLocation();
  const { auth } = useAuth();
  //console.log(auth);
  localStorage.setItem("usuario", JSON.stringify(auth.user));

  if (["/login", "/register", "/forgot-password"].includes(location.pathname)) {
    document.body.classList.add("login-page");
  } else {
    document.body.classList.remove("login-page");
  }

  return (
    <>
      <Routes>
        {/* public routes */}
        <Route path="login" element={<Login />} />

        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
            <Route path="/" element={<Layout Auth={auth} />}>
              <Route index element={<Home />} />
               <Route
                path="alumnos/listado" element={<ListadoAlumnos  />}
              />    
              <Route path="/perfil" element={<PerfilUsuario Auth={auth}/>} />              
              <Route path="conceptos" element={<Conceptos Auth={auth}/>} />              
              <Route path="cargos" element={<Cargos Auth={auth}/>} />
              <Route path="pagos" element={<Pagos Auth={auth}/>} />  

              <Route path="pagos/manual" element={<PagosManual Auth={auth} />} />
              <Route path="pagos/masivo" element={<PagosMasivos Auth={auth} />} />
              <Route path="pagos/historial" element={<PagosHistorial Auth={auth} />} />

              <Route path="estado-cuenta" element={<EstadoCuenta Auth={auth}/>} />              
              <Route path="inventario" element={<Inventario Auth={auth}/>} />    
              <Route path="facturacion" element={<Facturacion Auth={auth}/>} />          
              <Route path="faltas">
                <Route index element={<Faltas />} />
                <Route path=":idFalta" element={<Faltas />} />
                <Route path="listado" element={<ListadoFaltas />} />
              </Route>              
            </Route>
          </Route>
        </Route>
        {/* <Route path="unauthorized" element={<Unauthorized />} /> */}
        {/* catch all */}
        {/* <Route path="*" element={<Missing />} /> */}
        {/* </Route> */}
      </Routes>
      {/* <Routes>
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[ROLES.Editor]} />}>
            <Route path="/editor" element={<Layout Auth={auth} />}>
              <Route index element={<EditorHome />} />
              <Route path="empleados/listado" element={<ListadoEmpleadosEditor />} />
              <Route path="empleados/transferir" element={<FormularioEmpleado />} />
              <Route path="faltas/transferir" element={<FaltasTransferencia Auth={auth}  />} />
              <Route path="ajustes" element={<Settings />} />
            </Route>
          </Route>
        </Route>
      </Routes> */}
      {/* <Routes>
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
            <Route path="/admin" element={<AdminShell />}>
              <Route index element={<Dashboard />} />
              <Route path="usuarios" element={<Users />} />
              <Route path="ajustes" element={<Settings />} />
            </Route>
          </Route>
        </Route>
      </Routes> */}
    </>
  );
}
